/**
 * Set before the OAuth redirect. After login, App reads it once to reset chat state (a plain refresh doesn't).
 */
export const SESSION_POST_LOGIN_CHAT_RESET_PENDING = 'fletch-post-login-chat-reset-pending';
